<template>
  <v-container id="informessecundario-ivt">
    <v-row class="text-center">
      <v-col cols="12">
        <v-card class="alineacentro DatosMatriculado">
          <v-card-title class="DatosMatriculado">
            <v-row class="text-center">
              <v-col cols="12">
                <v-card
                  dark
                  color="success"
                  class="alineacentro DatosMatriculado"
                >
                  <strong>INFORMES DE ESTUDIANTES DE NIVEL SECUNDARIO</strong>
                </v-card>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col>
                <v-spacer />
              </v-col>
            </v-row>
            <v-row class="text-center">
              <v-col cols="12" md="3" lg="3">
                <v-select
                  v-model="filtros.anio"
                  :items="listaanios"
                  label="Año"
                  item-text="anio"
                  item-value="anio"
                  height="20px"
                  v-on:change="listar"
                />
              </v-col>
              <v-col cols="12" md="3" lg="3">
                <v-select
                  v-model="filtros.idperiodo"
                  :items="listatemporalidadinformes.filter(t=> t.idtipotemporalidad===2)"
                  label="Periodo"
                  item-text="descripcion"
                  item-value="idperiodo"
                  height="20px"
                  v-on:change="listar"
                />
              </v-col>
              <v-col cols="12" md="3" lg="3">
                <v-select
                  v-model="filtros.ciclo"
                  :items="listaciclos"
                  label="Ciclo"
                  item-text="ciclo"
                  item-value="idciclo"
                  height="20px"
                  v-on:change="listar"
                />
              </v-col>
              <v-col cols="12" md="3" lg="3" class="alineaizquierda">
                <v-btn
                  class="ma-2"
                  x-small
                  color="blue"
                  title="Listar Cursadas"
                  @click="listar"
                  :disabled="!permisolectura"
                >
                  <v-icon dark> mdi-magnify</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row class="text-center">
              <v-col cols="12" class="alineaizquierda">
                <v-btn
                  class="ma-2"
                  x-small
                  color="orange"
                  title="Ver Informes"
                  @click="verinformesalumnos"
                  v-if="permisoescritura && lista.length>0 && !roles.includes(7) && filtros.ciclo>0 && lista.filter(p=>p.idestadoinforme>0).length>0"
                >
                  <v-icon dark> mdi-account-eye</v-icon>
                </v-btn>
                <v-btn
                  class="ma-2"
                  x-small
                  color="#B700E8"
                  title="Enviar Informes"
                  @click="enviarinformes"
                  v-if="1===2"
                >
                  <v-icon dark>mdi-send</v-icon> Enviar Informes
                </v-btn>
              
              </v-col>
            </v-row>
            <v-row class="text-center">
              <v-col cols="12">
                <v-data-table
                  :headers="columnas"
                  :items="lista"
                  :items-per-page="lista.length"
                  hide-default-footer
                  item-key="idcatedra"
                  class="elevation-1"
                  dense
                  no-data-text="Sin Registros"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          icon
                          color="green"
                          @click="editarinforme(item)"
                          v-bind="attrs"
                          v-on="on"
                          :disabled="!item.permiteeditarinforme"
                        >
                          <v-icon>mdi-format-list-numbered-rtl</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar Informe</span>
                    </v-tooltip>
                    &nbsp;
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          icon
                          color="blue"
                          @click="abrecambiarestadoinforme(item)"
                          v-bind="attrs"
                          v-on="on"
                          v-show="item.permitecambiarestadoinforme"
                        >
                          <v-icon>mdi-state-machine</v-icon>
                        </v-btn>
                      </template>
                      <span>Cambiar Estado Informe</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:item.estadoinforme="{ item }">
                    <v-chip :color="getcolorestadoinforme(item.idestadoinforme)" dark>
                      <p class="textofilagrilla">{{ item.estadoinforme }}</p>
                    </v-chip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogmensaje" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ mensajetitulo }}
        </v-card-title>
        <v-card-text>
          {{ mensajecuerpo }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="dialogmensaje = false;if (mensajehome === true) {$router.push('Home');}"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loading" full-width>
      <v-container
        fluid
        class="full-height"
        style="background-color: rgba(255, 255, 255, 0.5)"
      >
        <v-row
          align="center"
          justify="center"
          style="height: 100vh"
          no-gutters
          dense
        >
          <v-col class="elementocentrado">
            <v-progress-circular indeterminate color="primary" />
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>
    <v-dialog v-model="dialoginforme" persistent full-width>
      <v-card>
        <v-card-title class="headline">
          {{ dialoginformetitulo }}
        </v-card-title>
        <v-card-actions>
          <v-row>
            <v-col cols="12" class="alineaderecha">
              <v-btn color="green darken-1" text @click="guardarinforme">
                Guardar
              </v-btn>
              <v-btn color="red darken-1" text @click="dialoginforme = false">
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
          <br />
          <br />
        </v-card-actions>
        <v-card-text>
          <br />
          <br />
          <v-row class="text-center">
            <v-col cols="12" md="1" lg="1" class="alineaizquierda titulodialog">
              Ciclo: {{ editedinforme.ciclolectivo }}
            </v-col>
            <v-col cols="12" md="2" lg="2" class="alineaizquierda titulodialog">
              Período: {{ editedinfextra.informedescripcion }}
            </v-col>
            <v-col cols="12" md="4" lg="4" class="alineaizquierda titulodialog">
              Asignatura: {{ editedinfextra.asignatura }}
            </v-col>
            <v-col cols="12" md="2" lg="2" class="alineaizquierda titulodialog">
              División: {{ editedinfextra.division }}
            </v-col>
            <v-col cols="12" md="3" lg="3" class="alineaizquierda titulodialog">
              Docente: {{ editedinfextra.docente }}
            </v-col>
          </v-row>
          <br />
          <br />
          <v-row class="text-center">
            <v-col cols="12" class="alineaizquierda">
              <v-text-field
                v-model="editedinforme.nombre"
                label="Nombre"
                height="20px"
                v-show="false"
              />
            </v-col>
          </v-row>
          <v-row class="text-center">
            <v-col cols="12">
              <v-textarea name="input-5-1"
                v-model="editedinforme.observacion"
                label="Observaciones"
                rows="2"
                row-height="15"
              />
            </v-col>
          </v-row>
          <v-row class="text-center">
            <v-col cols="12" class="alineaizquierda">
               <v-tooltip bottom>
                 <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      text
                      color="green"
                      @click="apruebavaloraciontodas"
                      v-bind="attrs"
                      v-on="on"
                      v-show="!roles.includes(7) && editedinforme.notas.filter(p=> p.idestado!=1).length===0"
                    >
                      <v-icon>mdi-thumb-up</v-icon> | Aprobar Todas las Valoraciones
                    </v-btn>
                  </template>
                 <span>Aprobar Todas las Valoraciones</span>
               </v-tooltip>
            </v-col>  
          </v-row>
          <v-row class="text-center">
            <v-col cols="12">
              <v-data-table
                :headers="columnasdetalle"
                :items="editedinforme.notas"
                :items-per-page="editedinforme.notas.length"
                hide-default-footer
                item-key="idalumno"
                class="elevation-1"
                dense
                no-data-text="Sin Registros"
              >
                <template v-slot:item.notanumerica="{ item }">
                  <v-text-field
                    v-model="item.notanumerica"
                    label="Nota"
                    height="20px"
                    type="number"
                    :rules="[rulesnotas.rango]"
                    @keydown="validarEntero"
                  />
                </template>
                <template v-slot:item.notavaloracion="{ item }">
                  <v-select
                      v-model="item.idnotavaloracion"
                      :items="listanotasvaloracion"
                      label="Val"
                      item-text="mnemo"
                      item-value="idnotavaloracion"
                      height="20px"
                  />
                </template>
                <template v-slot:item.concepto="{ item }">
                  <v-row class="text-center">
                    <v-col cols="12" md="9" lg="9">
                      <v-textarea name="input-5-1"
                        v-model="item.concepto"
                        label="Observación"
                        rows="1"
                        row-height="1"
                      />
                    </v-col>
                    <v-col cols="12" md="3" lg="3">
                      <br />
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            small
                            icon
                            color="orange"
                            @click="abreobservacion(item)"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon>mdi-forum-plus</v-icon>
                          </v-btn>
                        </template>
                        <span>Agregar Observación</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:item.estado="{ item }">
                  <v-chip :color="getcolorestadodetalle(item.idestado)" dark>
                    <p class="textofilagrilla">{{ item.estado }}</p>
                  </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        icon
                        color="green"
                        @click="apruebavaloracion(item)"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="!item.permiteaprobar || item.idestado===2"
                        v-show="!roles.includes(7)"
                      >
                        <v-icon>mdi-thumb-up</v-icon>
                      </v-btn>
                    </template>
                    <span>Aprobar</span>
                  </v-tooltip>
                  &nbsp;
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        icon
                        color="red"
                        v-bind="attrs"
                        v-on="on"
                        @click="abredesapruebavaloracion(item)"
                        :disabled="!item.permitedesaprobar || item.idestado===3"
                        v-show="!roles.includes(7)"
                      >
                        <v-icon>mdi-thumb-down</v-icon>
                      </v-btn>
                    </template>
                    <span>Desaprobar</span>
                  </v-tooltip>
                  &nbsp;
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        icon
                        color="green"
                        v-bind="attrs"
                        v-on="on"
                        @click="item.idestado=4; item.estado=listaestadosdetalles.filter(p=>p.idestado===4)[0].nombre;"
                        :disabled="item.idestado===4"
                        v-show="item.idestado===3 && item.obssupervision.length>0 && roles.includes(7)"
                      >
                        <v-icon>mdi-thumb-up</v-icon>
                      </v-btn>
                    </template>
                    <span>Marcar como corregido</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        class="ma-2"
                        color="red"
                        text-color="white"
                        v-bind="attrs"
                        v-on="on"
                        v-show="(item.idestado===3 || item.idestado===4) && item.obssupervision.length>0"
                      >
                        Obs.
                      </v-chip>
                    </template>
                    <span>{{item.obssupervision}}</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogdesapro" max-width="350">
      <v-card>
        <v-card-title class="text-h5">
          Desaprueba la valoración
        </v-card-title>
        <v-card-text>
          <v-row class="text-center">
            <v-col cols="12" class="alineaizquierda">
              Ingrese la observación de la desaprobación para que el Docente de la asignatura pueda verla:
            </v-col>
          </v-row>
          <v-row class="text-center">
            <v-col cols="12" class="alineaizquierda">
              <v-textarea name="input-5-1"
                v-model="obssupervision"
                label="Observación"
                rows="2"
                row-height="15"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="desapruebavaloracion"
          >
            Grabar
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="obssupervision = ''; dialogdesapro = false"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogcambioestado" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">
          Cambiar Estado del Informe
        </v-card-title>
        <v-card-actions>
          <v-row>
            <v-col cols="12" class="alineaderecha">
              <v-btn color="green darken-1" text @click="cambiaestadoinforme">
                Cambiar Estado
              </v-btn>
              <v-btn color="red darken-1" text @click="dialogcambioestado = false">
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
          <br />
          <br />
        </v-card-actions>
        <v-card-text>
          <br />
          <br />
          <v-row class="text-center">
            <v-col cols="12" class="alineacentro titulodialog">
              Estado Actual: 
              <v-chip :color="getcolorestadoinforme(cambioestado.idestadoactual)" dark>
                <p class="textofilagrilla">{{ cambioestado.estadoactual }}</p>
              </v-chip>
            </v-col>
          </v-row>
          <br />
          <br />
          <v-row class="text-center">
            <v-col cols="12" class="alineacentro">
              <v-select
                  v-model="cambioestado.idestadonuevo"
                  :items="listaestadosinformes"
                  label="Nuevo Estado"
                  item-text="nombre"
                  item-value="idestado"
                  height="20px"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogverinformes" persistent max-width="840">
      <v-card>
        <v-card-title class="headline">
          {{ dialogverinformestitulo }}
        </v-card-title>
        <v-card-actions>
          <v-row>
            <v-col cols="12" class="alineaderecha">
              <v-btn color="red darken-1" text @click="dialogverinformes = false">
                Cerrar
              </v-btn>
            </v-col>
          </v-row>
          <br />
          <br />
        </v-card-actions>
        <v-card-text>
          <v-row class="text-center">
            <v-col cols="12">
              <v-select
                  v-model="filtrosalu.iddivision"
                  :items="listadivisionesalumnosinf"
                  label="División"
                  item-text="division"
                  item-value="iddivision"
                  height="20px"
                  v-on:change="listaalumnosparainformes(false)"
              />
            </v-col>
          </v-row>
          <v-row class="text-center">
            <v-col cols="12">
              <v-card>
                <v-card-title>
                  Estudiantes:
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="filtrosalu.busca"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="columnasaluinf"
                  :items="listainformesalumnos"
                  :items-per-page="listainformesalumnos.length"
                  hide-default-footer
                  item-key="idalumno"
                  class="elevation-1"
                  dense
                  no-data-text="Sin Registros"
                  :search="filtrosalu.busca"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          icon
                          color="green"
                          @click="imprimeinforme(item)"
                          v-bind="attrs"
                          v-on="on"
                          :disabled="!item.permiteverinforme"
                        >
                          <v-icon>mdi-printer</v-icon>
                        </v-btn>
                      </template>
                      <span>Imprimir Informe</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogobserva" persistent max-width="840">
      <v-card>
        <v-card-title class="headline">
          Edita Observación
        </v-card-title>
        <v-card-actions>
          <v-row>
            <v-col cols="12" class="alineaderecha">
              <v-btn color="green darken-1" text @click="guardarobservacion">
                Guardar
              </v-btn>
              <v-btn color="red darken-1" text @click="dialogobserva = false">
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
          <br />
          <br />
        </v-card-actions>
        <v-card-text>
          <v-row class="text-center">
            <v-col cols="12">
              <v-textarea name="input-5-1"
                v-model="itemobstexto"
                label="Observación"
                rows="20"
                row-height="20"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <ConfirmDlg ref="confirm" />
  </v-container>
</template>
<script>
import axios from "@/axios";
import ConfirmDlg from "../Confirm.vue";
export default {
  name: "informessecundario",
  components: {
    ConfirmDlg: ConfirmDlg
  },
  data() {
    return {
      /*v-show="permisoescritura && lista.length>0 && lista.filter(p=> p.idestadoinforme<7).length===0 && !roles.includes(7)"*/
      loading: false,
      usuario: '',
      permisolectura: false,
      permisoescritura: false,
      idrol: 0,
      roles: [],
      nromodulo: 24,
      dialogmensaje: false,
      mensajetitulo: '',
      mensajecuerpo: '',
      mensajehome: false,
      columnas: [
        {
          text: "Op.",
          value: "actions",
          width: 75
        },
        {
          text: "Inf N°",
          align: "center",
          sortable: true,
          value: "nroinforme",
          width: 80
        },
        {
          text: "Inf.",
          align: "center",
          sortable: true,
          value: "descripcion",
          width: 90
        },
        {
          text: "Ciclo",
          align: "center",
          sortable: true,
          value: "ciclo",
          width: 65
        },
        {
          text: "Asignatura",
          align: "left",
          sortable: true,
          value: "asignaturacompleta",
          width: 250
        },
        {
          text: "Div.",
          align: "center",
          sortable: true,
          value: "division",
          width: 75
        },
        {
          text: "Docente",
          align: "left",
          sortable: true,
          value: "docente",
          width: 120
        },
        /* {
          text: "ID",
          align: "center",
          sortable: true,
          value: "idinforme",
          width: 70
        }, */
        /* {
          text: "Nombre",
          align: "left",
          sortable: true,
          value: "nombre",
          width: 140
        }, */
        {
          text: "Estado",
          align: "center",
          sortable: true,
          value: "estadoinforme",
          width: 70
        },
        {
          text: "F. Estado",
          align: "center",
          sortable: true,
          value: "fechaestadodmy",
          width: 120
        },
        {
          text: "Usuario",
          align: "center",
          sortable: true,
          value: "usuarioestado",
          width: 90
        }
      ],
      lista: [],
      listaanios: [],
      filtros: {
        anio: 0,
        idperiodo: 0,
        ciclo: 1
      },
      editedinforme: {
        idinforme: 0,
        ciclolectivo: 0,
        idtipotemporalidad: 0,
        idperiodo: 0,
        nombre: '',
        observacion: '',
        iddivision: 0,
        idasignatura: 0,
        iddocente: 0,
        idestado: 0,
        notas: [],
        usuario: ''
      },
      editedinfextra: {
        informedescripcion: '',
        docente: '',
        asignatura: '',
        division: ''
      },
      dialoginforme: false,
      dialoginformetitulo: '',
      listatipostemporalidad: [],
      listatemporalidadinformes: [],
      columnasdetalle: [
        {
          text: "Op.",
          value: "actions",
          width: 60,
          align: "center"
        },
        /* {
          text: "ID",
          align: "center",
          sortable: true,
          value: "idalumno",
          width: 55
        }, */
        {
          text: "DNI",
          align: "center",
          sortable: true,
          value: "nrodoc",
          width: 70
        },
        {
          text: "Estudiante",
          align: "left",
          sortable: true,
          value: "alumno",
          width: 130
        },
        {
          text: "Nota",
          align: "center",
          sortable: true,
          value: "notanumerica",
          width: 70
        },
        {
          text: "Valoración",
          align: "center",
          sortable: true,
          value: "notavaloracion",
          width: 80
        },
        {
          text: "Observación",
          align: "center",
          sortable: true,
          value: "concepto",
          width: 200
        },
        {
          text: "Estado",
          align: "center",
          sortable: true,
          value: "estado",
          width: 80
        }
      ],
      listadivisiones: [],
      listaasignaturas: [],
      listanotasvaloracion: [],
      dialogcambioestado: false,
      cambioestado: {
        idinforme: 0,
        idestadoactual: 0,
        estadoactual: '',
        idestadonuevo: 0,
        usuario: ''
      },
      listaestadosinformes: [],
      listaestadosdetalles: [],
      dialogdesapro: false,
      obssupervision: '',
      idalumnodesvalora: 0,
      dialogverinformes: false,
      listainformesalumnos: [],
      listaciclos: [{idciclo: 0, ciclo: '(TODOS)'},{idciclo: 1, ciclo: 'PRIMER AÑO'},{idciclo: 2, ciclo: 'SEGUNDO AÑO'},{idciclo: 3, ciclo: 'TERCER AÑO'}
        ,{idciclo: 4, ciclo: 'CUARTO AÑO'},{idciclo: 5, ciclo: 'QUINTO AÑO'},{idciclo: 6, ciclo: 'SEXTO AÑO'}],
      columnasaluinf: [
        {
          text: "Op.",
          value: "actions",
          width: 70
        },
        {
          text: "N° Documento",
          align: "center",
          sortable: true,
          value: "nrodoc",
          width: 100
        },
        {
          text: "Apellidos",
          align: "left",
          sortable: true,
          value: "apellido",
          width: 130
        },
        {
          text: "Nombres",
          align: "left",
          sortable: true,
          value: "nombre",
          width: 130
        },
        {
          text: "División",
          align: "center",
          sortable: true,
          value: "division",
          width: 110
        }
      ],
      listadivisionesalumnosinf: [],
      filtrosalu: {
        iddivision: 0,
        busca: ''
      },
      itemobservado: {},
      itemobstexto: '',
      dialogobserva: false,
      rulesnotas: {
        rango: value => {
          const val = parseInt(value);
          return (val >= 1 && val <= 10) || 'La Nota debe estar entre 1 y 10';
        },
      },
    };
  },
  mounted() {
    this.loading = true;
    this.roles=[];
    this.usuario = localStorage.getItem("user");
    var permisos = JSON.parse(localStorage.getItem("permisos"));
    var rolesuser = localStorage.getItem("rolesuserid").split(',');
    rolesuser.forEach((elemento) => {
        this.roles.push(parseInt(elemento));
    });
    var existeper = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 1);
    if (existeper.length === 0) {
      this.loading = false;
      this.MostrarMensaje("Error","No tiene permisos para acceder a este módulo.",true);
    } else {
      this.permisolectura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 2).length > 0 ? true : false;
      this.permisoescritura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 3).length > 0 ? true : false;
      var i=0;
      var anioactual= (new Date()).getFullYear();
      for(i=2026;i<=anioactual;i++) {
        this.listaanios.push({anio: i});
      }
      this.filtros.anio= (new Date()).getFullYear();
      axios.post('secundario/PostListaTiposTemporalidadesyPeriodos', { headers: { "Content-Type": "application/json"}}).then((result) => {
        if(result.data.resultado===0){
          this.listatipostemporalidad = result.data.datos[0];
          this.listatemporalidadinformes = result.data.datos[1];
          this.filtros.idperiodo=11;
          axios.post('secundario/PostListaNotasValoracion', { headers: { "Content-Type": "application/json"}}).then((result) => {
            if(result.data.resultado===0){
              this.listanotasvaloracion = result.data.datos;
              axios.post('secundario/PostListaEstadosDetallesInformes', { headers: { "Content-Type": "application/json"}}).then((result) => {
                if(result.data.resultado===0){
                  this.listaestadosdetalles = result.data.datos;
                  this.listar();
                }else{
                  this.loading = false;
                  this.MostrarMensaje("Error", result.data.resultadomensaje, false);
                }
              }).catch((error) => {
                  this.loading = false;
                  this.MostrarMensaje("Error", error, false);
              });
            }else{
              this.loading = false;
              this.MostrarMensaje("Error", result.data.resultadomensaje, false);
            }
          }).catch((error) => {
              this.loading = false;
              this.MostrarMensaje("Error", error, false);
          });
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
      });
    }
  },
  methods: {
    MostrarMensaje(titulo, cuerpo, home) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.mensajehome = home != null ? home : false;
      this.dialogmensaje = true;
    },
    getcolorestadoinforme (estado) {
      if (estado === 0) {return "grey";}
      else if (estado === 1) {return "#A5CCF0";}
      else if (estado === 2) {return "#03E6FF";}
      else if (estado === 3) {return "green";}
      else if (estado === 4) {return "red";}
      else if (estado === 5) {return "orange";}
      else if (estado === 6) {return "black";}
      else if (estado === 7) {return "blue";}
      else if (estado === 8) {return "#B700E8";}
    },
    listar () {
      this.loading = true;
      var parametros= JSON.stringify({anio: this.filtros.anio,idperiodo: this.filtros.idperiodo, usuario: this.usuario});
      axios.post('secundario/PostListaInformesSecundaria',parametros, { headers: { "Content-Type": "application/json",}}).then((result) => {
        if(result.data.resultado===0){
          var datos= result.data.datos;
          if(this.filtros.ciclo>0)
          {
            datos = datos.filter(p=>p.ciclo===this.filtros.ciclo);
          }
          this.lista = datos;
          this.loading = false;
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
      });
    },
    /* agregarinforme () {
      this.loading=true;
      var parametros= JSON.stringify({usuario: this.usuario, anio: this.filtros.anio});
      axios.post("secundario/PostAsignaturasxUsuario",parametros, { headers: { "Content-Type": "application/json",}}).then((result) => {
        if(result.data.resultado===0){
          this.listaasignaturas = result.data.datos;
          this.dialoginformetitulo='Nuevo Informe';
          this.editedinforme= {
            idinforme: 0,
            ciclolectivo: (new Date()).getFullYear(),
            idtipotemporalidad: 2,
            idperiodo: 11,
            nombre: '',
            observacion: '',
            iddivision: 0,
            idasignatura: this.listaasignaturas.length>0 ? this.listaasignaturas[0].idasignatura : 0,
            iddocente: 0,
            idestado: 1,
            notas: [],
            usuario: this.usuario
          };
          this.cargadivisiones(true, 0);
        }else{
          this.loading = false;
          this.MostrarMensaje('Error', result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje('Error', error, false);
      });
    }, */
    cargadivisiones (abredialogo, idinforme) {
      var parametros= JSON.stringify({usuario: this.usuario, anio: this.filtros.anio, idasignatura: this.editedinforme.idasignatura});
      axios.post("secundario/PostDivisionesXUsuarioAnioAsignatura",parametros, { headers: { "Content-Type": "application/json",}}).then((result) => {
        if(result.data.resultado===0){
          this.listadivisiones = result.data.datos;
          var paramdoc='';
          var paraminf='';
          if(abredialogo) 
          {
            if(idinforme===0)
            {
              this.editedinforme.iddivision= this.listadivisiones.length>0 ? this.listadivisiones[0].iddivision : 0;

              if(this.roles.includes(7)) {
                this.editedinforme.iddocente= parseInt(localStorage.getItem("idpersona"));
                this.editedinfextra.docente= localStorage.getItem('username');
              }else{
                paramdoc = JSON.stringify({anio: this.filtros.anio, idasignatura: this.editedinforme.idasignatura, iddivision: this.editedinforme.iddivision });
                axios.post("secundario/PostBuscaDocentexAnioAsignaturaDivision",paramdoc, { headers: { "Content-Type": "application/json",}}).then((result) => {
                  if(result.data.resultado===0){
                    this.editedinforme.iddocente= result.data.datos.iddocente;
                    this.editedinfextra.docente= result.data.datos.docente;
                  }else{
                    this.editedinforme.iddocente=0;
                    this.editedinfextra.docente='Sin Docente Designado';
                  }
                }).catch((error) => {
                  this.loading = false;
                  this.MostrarMensaje('Error', error, false);
                });
              }

              paraminf= JSON.stringify({usuario: this.usuario, anio: this.filtros.anio, idinforme: 0, idasignatura: this.editedinforme.idasignatura, iddivision: this.editedinforme.iddivision });
              axios.post("secundario/PostTraeInforme",paraminf, { headers: { "Content-Type": "application/json",}}).then((result) => {
                if(result.data.resultado===0){
                  this.editedinforme.notas= result.data.datos.notas;
                  this.loading = false;
                  this.dialoginforme=true;
                }else{
                  this.loading = false;
                  this.MostrarMensaje('Error', result.data.resultadomensaje, false);
                }
              }).catch((error) => {
                this.loading = false;
                this.MostrarMensaje('Error', error, false);
              });
            }else {
              paraminf= JSON.stringify({usuario: this.usuario, anio: 0, idinforme: idinforme, idasignatura: 0, iddivision: 0 });
              axios.post("secundario/PostTraeInforme",paraminf, { headers: { "Content-Type": "application/json",}}).then((result) => {
                if(result.data.resultado===0){
                  this.editedinforme.notas= result.data.datos.notas;
                  this.loading = false;
                  this.dialoginforme=true;
                }else{
                  this.loading = false;
                  this.MostrarMensaje('Error', result.data.resultadomensaje, false);
                }
              }).catch((error) => {
                this.loading = false;
                this.MostrarMensaje('Error', error, false);
              });
            }
          }else{
            this.editedinforme.iddivision= this.listadivisiones.length>0 ? this.listadivisiones[0].iddivision : 0;
            if(this.roles.includes(7)) {
              this.editedinforme.iddocente= parseInt(localStorage.getItem("idpersona"));
              this.editedinfextra.docente= localStorage.getItem('username');
            }else{
              paramdoc = JSON.stringify({anio: this.filtros.anio, idasignatura: this.editedinforme.idasignatura, iddivision: this.editedinforme.iddivision });
              axios.post("secundario/PostBuscaDocentexAnioAsignaturaDivision",paramdoc, { headers: { "Content-Type": "application/json",}}).then((result) => {
                if(result.data.resultado===0){
                  this.editedinforme.iddocente= result.data.datos.iddocente;
                  this.editedinfextra.docente= result.data.datos.docente;
                }else{
                  this.editedinforme.iddocente=0;
                  this.editedinfextra.docente='Sin Docente Designado';
                }
              }).catch((error) => {
                this.loading = false;
                this.MostrarMensaje('Error', error, false);
              });
            }

            paraminf= JSON.stringify({usuario: this.usuario, anio: this.filtros.anio, idinforme: this.editedinforme.idinforme, idasignatura: this.editedinforme.idasignatura, iddivision: this.editedinforme.iddivision });
            axios.post("secundario/PostTraeInforme",paraminf, { headers: { "Content-Type": "application/json",}}).then((result) => {
              if(result.data.resultado===0){
                this.editedinforme.notas= result.data.datos.notas;
                this.loading = false;
              }else{
                this.loading = false;
                this.MostrarMensaje('Error', result.data.resultadomensaje, false);
              }
            }).catch((error) => {
              this.loading = false;
              this.MostrarMensaje('Error', error, false);
            });
          }
        }else{
          this.loading = false;
          this.MostrarMensaje('Error', result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje('Error', error, false);
      });
    },
    seleccionaasignatura () {
      this.loading= true;
      this.cargadivisiones(false, this.editedinforme.idinforme);
    },
    seleccionadivision () {
      this.loading= true;
      if(this.roles.includes(7)) {
        this.editedinforme.iddocente= parseInt(localStorage.getItem("idpersona"));
        this.docenteasignaturadivision= localStorage.getItem('username');
      }else{
        var paramdoc = JSON.stringify({anio: this.filtros.anio, idasignatura: this.editedinforme.idasignatura, iddivision: this.editedinforme.iddivision });
        axios.post("secundario/PostBuscaDocentexAnioAsignaturaDivision",paramdoc, { headers: { "Content-Type": "application/json",}}).then((result) => {
          if(result.data.resultado===0){
            this.editedinforme.iddocente= result.data.datos.iddocente;
            this.docenteasignaturadivision= result.data.datos.docente;
          }else{
            this.editedinforme.iddocente=0;
            this.docenteasignaturadivision='Sin Docente Designado';
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje('Error', error, false);
        });
      }

      var paraminf= JSON.stringify({usuario: this.usuario, anio: this.filtros.anio, idinforme: this.editedinforme.idinforme, idasignatura: this.editedinforme.idasignatura, iddivision: this.editedinforme.iddivision });
      axios.post("secundario/PostTraeInforme",paraminf, { headers: { "Content-Type": "application/json",}}).then((result) => {
        if(result.data.resultado===0){
          this.editedinforme.notas= result.data.datos.notas;
          this.loading = false;
        }else{
          this.loading = false;
          this.MostrarMensaje('Error', result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje('Error', error, false);
      });
    },
    guardarinforme () {
      var valido= this.validarinforme();
      if (valido.length===0)
      {
        this.loading=true;
        var informe= JSON.stringify(this.editedinforme);
        axios.post("secundario/PostGuardaInformeSecundario",informe, { headers: { "Content-Type": "application/json",}}).then((result) => {
          if(result.data.resultado===0){
            this.dialoginforme= false;
            this.listar();
          }else{
            this.loading = false;
            this.MostrarMensaje('Error', result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje('Error', error, false);
        });
      }else{
        this.MostrarMensaje('Error', valido, false);
      }
    },
    validarinforme () {
      var valido= '';
      if(this.editedinforme.nombre.length===0) {
        valido='Debe ingresar nombre del informe!';
      }
      if(this.editedinforme.notas.length===0) {
        valido='No existen registros de estudiantes a valorar!';
      }else{
        if(this.editedinforme.idestado===2 && this.editedinforme.notas.filter(n=> n.idnotavaloracion===null).length>0) {
          valido='Hay estudiantes de la lista sin valorar!';
        }
      }
      if(this.editedinforme.notas.filter(n=> n.notanumerica!=null && (n.notanumerica<1 || n.notanumerica>10)).length>0)
      {
        valido='Hay notas numéricas cargadas no válidas (las notas deben ser valores enteros entre 1 y 10)!';
      }
      return valido;
    },
    editarinforme (item) {
      this.loading=true;
      var parametros= JSON.stringify({usuario: this.usuario, anio: this.filtros.anio});
      axios.post("secundario/PostAsignaturasxUsuario",parametros, { headers: { "Content-Type": "application/json",}}).then((result) => {
        if(result.data.resultado===0){
          this.listaasignaturas = result.data.datos;
          this.dialoginformetitulo= item.idinforme===null ? 'Nuevo Informe' : 'Editando Informe ID: ' + item.idinforme.toString();
          this.editedinforme= {
            idinforme: item.idinforme===null ? 0 : item.idinforme,
            ciclolectivo: item.ciclolectivo,
            idtipotemporalidad: item.idtipotemporalidad,
            idperiodo: item.idperiodo,
            nombre: item.nombre!=null && item.nombre.length>0 ? item.nombre : item.ciclolectivo.toString()+' - '+item.descripcion+' - '+item.asignatura+' - '+item.division,
            observacion: item.observacion,
            iddivision: item.iddivision,
            idasignatura: item.idasignatura,
            iddocente: item.iddocente,
            idestado: item.idestado,
            notas: [],
            usuario: this.usuario
          };
          this.editedinfextra= {
            informedescripcion: item.descripcion,
            docente: item.docente,
            asignatura: item.asignaturacompleta,
            division: item.division
          };
          this.cargadivisiones(true, item.idinforme===null ? 0 : item.idinforme);
        }else{
          this.loading = false;
          this.MostrarMensaje('Error', result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje('Error', error, false);
      });
    },
    abrecambiarestadoinforme (item) {
      this.loading= true;
      var parametros= JSON.stringify({usuario: this.usuario, idinforme: item.idinforme});
      axios.post("secundario/PostListaPosiblesEstadosInformeSecundariaxInforme",parametros, { headers: { "Content-Type": "application/json",}}).then((result) => {
        if(result.data.resultado===0){
          this.listaestadosinformes= result.data.datos;
          this.cambioestado= {
            idinforme: item.idinforme,
            idestadoactual: item.idestadoinforme,
            estadoactual: item.estadoinforme,
            idestadonuevo: this.listaestadosinformes.length>0 ? this.listaestadosinformes[0].idestado : 0,
            usuario: this.usuario
          };
          this.loading= false;
          this.dialogcambioestado= true;
        }else{
          this.loading = false;
          this.MostrarMensaje('Error', result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje('Error', error, false);
      });
    },
    getcolorestadodetalle (idestado) {
      if (idestado === 0) {return "grey";}
      else if (idestado === 1) {return "#A67DF3";}
      else if (idestado === 2) {return "green";}
      else if (idestado === 3) {return "red";}
      else if (idestado === 4) {return "blue";}
    },
    cambiaestadoinforme () {
      this.loading=true;
      var cambio= JSON.stringify(this.cambioestado);
      axios.post("secundario/PostCambioEstadoInformeSecundario",cambio, { headers: { "Content-Type": "application/json",}}).then((result) => {
        if(result.data.resultado===0){
          this.dialogcambioestado= false;
          this.listar();
        }else{
          this.loading = false;
          this.MostrarMensaje('Error', result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje('Error', error, false);
      });
    },
    abredesapruebavaloracion (item) {
      this.idalumnodesvalora= item.idalumno;
      this.obssupervision = item.obssupervision; 
      this.dialogdesapro = true
    },
    apruebavaloracion (item) {
      item.idestado=2;
      item.estado=this.listaestadosdetalles.filter(p=>p.idestado===2)[0].nombre;
    },
    desapruebavaloracion () {
      var item= this.editedinforme.notas.filter(p=> p.idalumno===this.idalumnodesvalora)[0];
      item.idestado = 3; 
      item.estado = this.listaestadosdetalles.filter(p=>p.idestado===3)[0].nombre; 
      item.obssupervision = this.obssupervision; 
      this.dialogdesapro = false;
    },
    enviarinformes () {
      
    },
    verinformesalumnos () {
      this.dialogverinformestitulo= 'Lista de Estudiantes'
      this.listaalumnosparainformes(true);
    },
    listaalumnosparainformes (abredialog) {
      this.loading= true;
      var parametros= JSON.stringify({usuario: this.usuario, anio: this.filtros.anio, idperiodo: this.filtros.idperiodo, ciclo: this.filtros.ciclo });
      axios.post("secundario/PostListaInformesXEstudiante",parametros, { headers: { "Content-Type": "application/json",}}).then((result) => {
        if(result.data.resultado===0){
          this.listainformesalumnos = result.data.datos;
          if (abredialog) {
            this.listadivisionesalumnosinf = [
              ...new Map(
                this.listainformesalumnos.map(item => [`${item.iddivision}-${item.division}`, { iddivision: item.iddivision, division: item.division }])
              ).values()
            ];
            this.listadivisionesalumnosinf.unshift({iddivision: 0, division: '(TODAS)'});
            this.filtrosalu.iddivision= 0;
            this.dialogverinformes= true;
          }
          if(this.filtrosalu.iddivision!=0)
          {
            this.listainformesalumnos=this.listainformesalumnos.filter(p=>p.iddivision===this.filtrosalu.iddivision);
          }
          this.loading = false;
        }else{
          this.loading = false;
          this.MostrarMensaje('Error', result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje('Error', error, false);
      });
    },
    imprimeinforme (item) {
      this.loading = true;
      axios.post("reportes/GetReporte", {idreporte: 24, formato: 'PDF', listaparametros: [{ orden: 1, nombre: "idalumno", valor: item.idalumno.toString()},{ orden: 2, nombre: "ciclolectivo", valor: this.filtros.anio.toString()} ] },{ headers: { "Content-Type": "application/json" }}).then((result) => {
        this.loading = false;
        if (result.data.toString().startsWith("Error") === false) {
          window.open(result.data, "_blank");
        } else {
          this.MostrarMensaje("Error", result.data, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    abreobservacion (item) {
      this.itemobservado= item;
      this.itemobstexto= item.concepto;
      this.dialogobserva= true;
    },
    guardarobservacion () {
      this.editedinforme.notas.filter(p=> p.idalumno===this.itemobservado.idalumno)[0].concepto= this.itemobstexto;
      this.dialogobserva=false;
    },
    validarEntero(e) {
      // Bloquea punto (.), letra e, signo menos (-)
      if (['.',',','e','-','+'].includes(e.key)) {
        e.preventDefault();
      }
    },
    apruebavaloraciontodas () {
      var i=0;
      var estado2= this.listaestadosdetalles.filter(p=>p.idestado===2)[0].nombre;
      for(i=0;i<this.editedinforme.notas.length;i++) {
        this.editedinforme.notas[i].idestado=2;
        this.editedinforme.notas[i].estado=estado2;
      }
    }
  },
  computed: {
    fechalocalfecha: function () {
      if (this.edited.fecha != null && this.edited.fecha != "") {
        var fecha = new Date(this.edited.fecha);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
  },
};
</script>
<style>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 0.680rem !important;
    height: 25px !important;
}

.titulodialog {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
}

.textofilagrilla {
  font-size: 0.680rem !important;
  height: 5px !important;
}

.v-application--is-ltr .v-banner--is-mobile .v-banner__wrapper {
    padding-left: 1px !important;
}

.v-banner--is-mobile .v-banner__wrapper {
    flex-wrap: wrap;
    padding-top: 1px !important;
}

.v-application--is-ltr .v-banner__wrapper {
    padding: 1px 1px 1px 1px !important;
}

.letraroja {
  color: red;
}
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa30 {
  width: 30%;
}
.ocupa50 {
  width: 50%;
}
.ocupa75 {
  width: 75%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.textoNegritaRojo {
  color: red !important;
  font-weight: bold !important;
}
.textoNegritaVerde {
  color: rgb(83, 248, 125) !important;
  font-weight: bold !important;
}
</style>